import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ApiService } from '../../services/api.service';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-cms-content',
  templateUrl: './cms-content.component.html',
  styleUrl: './cms-content.component.scss',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe, MatIconModule, MatDialogModule, MatButtonModule]
})
export class CMSContentComponent {
  content: any;
  header: any;
  selectedLang: string = '';

  constructor(
    public url: ApiUrlHelper,
    public apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.selectedLang = this.languageService.getLanguage();
    if (this.data?.content) {
      if (this.data.content == 'T&C') {
        this.getTermsAndConditions();
      } else {
        this.getPrivacyPolicy();
      }
    }
    this.languageService.language$.subscribe(() => {
      this.selectedLang = this.languageService.getLanguage();
  
      if (this.data?.content === 'T&C') {
        this.getTermsAndConditions();
      } else {
        this.getPrivacyPolicy();
      }
    });
  }

  getTermsAndConditions(): void {
    const apiUrl = this.url.apiUrl.termsAndConditionsMaster.getTermsAndConditions;
  
    this.apiService.doGet(apiUrl).subscribe((data: any) => {
      if (data?.Success && data.Data) {
        this.content =
          this.selectedLang === 'spa'
            ? data.Data.SpanishTermsAndConditions1
            : data.Data.TermsAndConditions1;
  
        this.header = this.selectedLang === 'spa' ? 'Condiciones de uso' : 'Terms of Use';
      }
    });
  }

  getPrivacyPolicy(): void {
    const apiUrl = this.url.apiUrl.privacyPolicyMaster.getprivacyPolicy;
  
    this.apiService.doGet(apiUrl).subscribe((data) => {
      if (data?.Success && data.Data) {
        this.content =
          this.selectedLang === 'spa'
            ? data.Data.SpanishPrivacyPolicy
            : data.Data.PrivacyPolicy;
  
        this.header = this.selectedLang === 'spa' ? 'Política de Privacidad' : 'Privacy Policy';
      }
    });
  }
  
  

  // getTermsAndConditions(): void {
  //   let apiUrl = this.url.apiUrl.termsAndConditionsMaster.getTermsAndConditions;
  //   this.apiService.doGet(apiUrl).subscribe((data: any) => {
  //     if (data?.Success && data.Data) {
  //       this.content = data.Data.TermsAndConditions1;
  //       this.header = 'Terms of use';
  //     }
  //   });
  // }

  // getPrivacyPolicy(): void {
  //   let apiUrl = this.url.apiUrl.privacyPolicyMaster.getprivacyPolicy;
  //   this.apiService.doGet(apiUrl).subscribe((data) => {
  //     if (data?.Success && data.Data) {
  //       this.content = data.Data.PrivacyPolicy;
  //       this.header = 'Privacy Policy';
  //     }
  //   });
  // }
}
